import { DocsHeader, DocsFooter } from "@/components/DocsChrome";
import { CodeAwareBody } from "@/lib/codeRenderer";

import markdownSource from "./_reviewer-test-plan.md?raw";

/**
 * `/reviewer-test-plan` — public docs page rendering the directory-reviewer
 * test plan. The source lives next to this file as `_reviewer-test-plan.md`
 * and is `?raw`-imported at build time so the markdown stays the
 * single source of truth.
 *
 * Linked from `docs/connector-directory-submission.md` and from the
 * submission form's "test account setup instructions" field — a reviewer
 * doesn't need access to the repo to find it.
 */
export function ReviewerTestPlan() {
  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-zinc-950 text-zinc-900 dark:text-zinc-100">
      <DocsHeader />

      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12 leading-relaxed">
        <CodeAwareBody body={markdownSource} />
      </main>

      <DocsFooter />
    </div>
  );
}
